import React, { useEffect } from "react"
import makeStyles from "@mui/styles/makeStyles"
import {useDispatch} from "react-redux"
import Card from "@mui/material/Card"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { Formik, Form } from "formik"
import { ChangePasswordSchema } from "../../utils/yupValidators"
import { changePassword, showLogin } from "../../actions/Utils/app"
import InputLabel from "@mui/material/InputLabel"
import Input from "@mui/material/Input"
import FormControl from "@mui/material/FormControl"
import LoginChecklist from "./LoginChecklist"

const useStyles = makeStyles({
    card: {
        background: "#fff",
        border: "1px solid #DBDBDB",
        boxSizing: "border-box",
        boxShadow: "0px 1px 2px rgba(0,0,0,.04)",
        borderRadius: 8,
        width: 364,
        "& .MuiCardContent-root": {
            padding: "32px 32px 0",
        },
        "& .MuiCardActions-root": {
            padding: "24px 32px 32px",
            justifyContent: "center",
        },
        "& .MuiButton-containedPrimary": {
            backgroundColor: "#2196F3",
            boxShadow: "0 1px 2px rgba(0,0,0,.18)",
        },
        "& .MuiButton-containedPrimary:hover": {
            backgroundColor: "#2196F3",
            boxShadow: "0 1px 2px rgba(0,0,0,.18)",
            filter: "brightness(.93)",
        },
    },
    title: {
        fontWeight: 500,
        fontSize: 20,
        lineHeight: "28px",
        color: "#555555",
        marginBottom: 24,
    },
    fieldBase: {
        width: "100%",
        fontSize: 16,
        "& .MuiInputLabel-root": { color: "#555555" },
        "& .MuiInputLabel-root.Mui-focused:not(.Mui-error)": { color: "#555555" },
        "& .MuiInput-underline:before": { borderBottomColor: "#DBDBDB" },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottomColor: "#BDBDBD",
            borderBottomWidth: 1,
        },
        "& .MuiInput-underline:after": { borderBottomWidth: 1 },
    },
    textField: {
        composes: "$fieldBase",
        marginTop: 20,
    },
    confirmField: {
        composes: "$fieldBase",
        marginTop: 18,
    },
    errorField: {
        color: "#F44259",
        marginTop: 7,
        fontSize: 13,
        lineHeight: "18px",
    },
})

const ChangeAccountPassword = (props) => {
    const {
        location
    } = props

    const classes = useStyles()
    const dispatch = useDispatch()

    const _showLogin = () => dispatch(showLogin())

    useEffect(() => {
        if (!location.query.app || !location.query.token || !location.query.username) {
            _showLogin()
        }
    }, [])

    const _changePassword = values => {
        dispatch(changePassword({
            token: location.query.token,
            newPassword: values.password,
            username: location.query.username
        }))
    }

    return (
        <div className="flexCenter height100">
            <Formik
                enableReinitialize
                initialValues={{
                    password: "",
                    confirmPassword: ""
                }}
                onSubmit={_changePassword}
                validationSchema={ChangePasswordSchema}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur
                }) => {
                    return (
                        <Form>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Typography className={classes.title}>
                                        Créer votre nouveau mot de passe
                                    </Typography>
                                    <FormControl className={classes.textField} variant="standard" error={!!errors.password}>
                                        <InputLabel>Nouveau mot de passe</InputLabel>
                                        <Input
                                            name="password"
                                            type="password"
                                            value={values.password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.password && (
                                            <div className={classes.errorField}>{errors.password}</div>
                                        )}
                                    </FormControl>
                                    <LoginChecklist
                                        password={values.password}
                                        touched={!!touched.password}
                                    />
                                    <FormControl className={classes.confirmField} variant="standard" error={!!errors.confirmPassword}>
                                        <InputLabel>Confirmer le mot de passe</InputLabel>
                                        <Input
                                            name="confirmPassword"
                                            type="password"
                                            value={values.confirmPassword}
                                            onChange={handleChange}
                                        />
                                        {errors.confirmPassword && (
                                            <div className={classes.errorField}>{errors.confirmPassword}</div>
                                        )}
                                    </FormControl>
                                </CardContent>
                                <CardActions>
                                    <Button
                                        color="primary"
                                        type="submit"
                                        variant="contained"
                                    >
                                        ENREGISTRER LE MOT DE PASSE
                                    </Button>
                                </CardActions>
                            </Card>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    )
}

export default ChangeAccountPassword
